import rozcestnikPostavil from "../../content/rozcestnik/rozcestnikPostavil";
import rozcestnikPostavil2 from "../../content/rozcestnik/rozcestnikPostavil2";
import rozcestnikPostavil3 from "../../content/rozcestnik/rozcestnikPostavil3";
import { renderLoginComponent } from "../../components/Login";
import { initRozcestnikZapisy } from "./rozcestnikZapisyService";
import { initRozcestnik } from "./rozcestnikService";
import { destroyElement } from "../../utils/common.mjs";

export function initRozcestnikPostavil(isPublic) {
   
    const tilesDiv = document.getElementById('tiles');
    tilesDiv.innerHTML = "";

    tilesDiv.appendChild(rozcestnikPostavil());
    tilesDiv.style.display = "block";

    const divFormio = document.getElementById('divFormio');
    divFormio.style.display = "none";
    destroyElement('back-button-services');

    let rozcestnikPostavil2Tile = document.getElementById('rozcestnikPostavil2Tile');
    rozcestnikPostavil2Tile.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikPostavil2(isPublic);
    });

    let rozcestnikPostavil3Tile = document.getElementById('rozcestnikPostavil3Tile');
    rozcestnikPostavil3Tile.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikPostavil3(isPublic);
    });

    let rozcestnikPostavilS8414 = document.getElementById('rozcestnikPostavilS8414');
    
    if (isPublic) {
        rozcestnikPostavilS8414.addEventListener("click", event => {
            event.preventDefault();
            renderLoginComponent('S8414');
        });
    
    } else {
        rozcestnikPostavilS8414.addEventListener("click", event => {
            event.preventDefault();
            window.initFormio('S8414', null, null);
        });
    
    }

    initRozcestnikBreadcrumbs(isPublic);

}

function initRozcestnikPostavil2(isPublic) {

    const tilesDiv = document.getElementById('tiles');
    tilesDiv.innerHTML = "";

    tilesDiv.appendChild(rozcestnikPostavil2(isPublic));
    tilesDiv.style.display = "block";

    const divFormio = document.getElementById('divFormio');
    divFormio.style.display = "none";
    destroyElement('back-button-services');

    const postavilJsemStavbu = document.getElementById('postavilJsemStavbu');
    postavilJsemStavbu.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikPostavil(isPublic);
    });

    let rozcestnikPostavil2S8414 = document.getElementById('rozcestnikPostavil2S8414');

    if (isPublic) {
        rozcestnikPostavil2S8414.addEventListener("click", event => {
            event.preventDefault();
            renderLoginComponent('S8414');
        });

    } else {
        rozcestnikPostavil2S8414.addEventListener("click", event => {
            event.preventDefault();
            window.initFormio('S8414', null, null);
        });

    }

    initRozcestnikBreadcrumbs(isPublic);

}

function initRozcestnikPostavil3(isPublic) {

    const tilesDiv = document.getElementById('tiles');
    tilesDiv.innerHTML = "";

    tilesDiv.appendChild(rozcestnikPostavil3(isPublic));
    tilesDiv.style.display = "block";

    const divFormio = document.getElementById('divFormio');
    divFormio.style.display = "none";
    destroyElement('back-button-services');

    const postavilJsemStavbu = document.getElementById('postavilJsemStavbu');
    postavilJsemStavbu.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikPostavil(isPublic);
    });

    let rozcestnikPostavil3S8414 = document.getElementById('rozcestnikPostavil3S8414');
    // let rozcestnikPostavil3S8419 = document.getElementById('rozcestnikPostavil3S8419');

    if (isPublic) {
        rozcestnikPostavil3S8414.addEventListener("click", event => {
            event.preventDefault();
            renderLoginComponent('S8414');
        });

    } else {
        rozcestnikPostavil3S8414.addEventListener("click", event => {
            event.preventDefault();
            window.initFormio('S8414', null, null);
        });

    }

    // if (isPublic) {
    //     rozcestnikPostavil3S8419.addEventListener("click", event => {
    //         event.preventDefault();
    //         initPrihlaseni('S8419');
    //     });

    // } else {
    //     rozcestnikPostavil3S8419.addEventListener("click", event => {
    //         event.preventDefault();
    //         initFormio('S8419', null, null);
    //     });

    // }

    initRozcestnikBreadcrumbs(isPublic);

}

function initRozcestnikBreadcrumbs(isPublic) {

    const home = document.getElementById('rozcestnikRoot');
    home.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnik(isPublic);

    });

    const rozcestnikZapisy = document.getElementById('rozcestnikZapisy');
    if (rozcestnikZapisy) {
        rozcestnikZapisy.addEventListener("click", event => {
            event.preventDefault();
            initRozcestnikZapisy(isPublic);
        })
    }

    const postavilJsemStavbu = document.getElementById('postavilJsemStavbu');
    if (postavilJsemStavbu) {
        postavilJsemStavbu.addEventListener("click", event => {
            event.preventDefault();
            initRozcestnikPostavil(isPublic);
        })
    }
}